// App-level default thresholds for the mode-level urgency indicator (D1).
//
// Per the doctrine's two-tier threshold model:
//   - Org-editable preferences (e.g. sales-rep lead-interaction alerts) live in
//     org admin / trainer settings — added per-setting as each opt-in matures.
//   - App-level defaults (the constants below) decide when *any* mode glows
//     out-of-the-box. Hardcoded for v1; a future dev-panel can expose these
//     as tunable constants without changing the public contract.
//
// Numbers chosen to be conservative: the "amber" window must be tight enough
// that a salesperson glancing at the rail mid-call sees urgency that's
// actually about to bite, not "sometime today." 30 minutes matches the
// instinctive "I should head over there now" window.

/** Window before a follow-up's `due_date` during which the mode glows amber. */
export const SALES_CONSOLE_DUE_SOON_MS = 30 * 60 * 1000;

/**
 * When true, any open follow-up whose `due_date` falls on today's local
 * calendar day (but outside the 30-minute amber window) still drives an amber
 * urgency. This keeps the badge useful for "follow up later today" patterns
 * without forcing the user to refresh near the cutoff.
 *
 * If we find this too noisy in pilot, flip to false and the badge will only
 * glow for the next-30-min and overdue cases.
 */
export const SALES_CONSOLE_DUE_TODAY_AMBER = true;

// Red threshold is implicit: any open follow-up with `due_date` < now drives
// a red urgency. No constant required (delta < 0).
